import React, { useEffect, useRef, useState } from "react";
import { Container } from "react-bootstrap";
import { connect } from "react-redux";
import { baseURL, headers } from "../../../../../global/api";
import { deleteCustomer, updateCustomer } from "./Customer.action";
import { setHeading } from "../../../accounts/account.actions";
import { PDFHeader } from "../../../../../global/globalFunctions";
import MaterialTable from "material-table";
import EditCustomer from "./EditCustomer";
import EditIcon from "@mui/icons-material/Edit";
import jsPDF from "jspdf";


const ViewCustomer = (props) => {
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const tableRef = useRef();
  const permissions = JSON.parse(window.localStorage.getItem("permissions"));
  const Checkpermissions = (permissionsType, permissionsName) => {
    return permissions.some((p) => p[`${permissionsType}`] === permissionsName) ? false : true;
  };


  const handleEditClick = (rowData) => {
    setSelectedRow(rowData);
    setEditModalOpen(true);
  };

  const handleEditSave = (updatedData) => {
    props.updateCustomer(updatedData, selectedRow);
    setTimeout(() => {
      tableRef.current && tableRef.current.onQueryChange();
    }, 700);
  };


  useEffect(() => {
    props.setHeading("Customer List");
  }, []);

  return (
    <>
      <EditCustomer
        show={editModalOpen}
        onHide={() => setEditModalOpen(false)}
        rowData={selectedRow}
        onSave={handleEditSave}
      />

      <Container fluid>
        <MaterialTable
          tableRef={tableRef}
          title="Customer List"
          columns={[
            { title: 'S.No', field: 'sequenceNumber', editable: 'never' },
            { title: "Customer Name", field: "name" },
            { title: "Customer Phone", field: "phone" },
            { title: "Customer Email", field: "email" },
            { title: "Customer Address", field: "address" },
            {
              title: "Filer Status", field: "filerStatus", editable: 'never',
              render: (rowData) => (
                <div
                  style={{
                    backgroundColor: rowData.filerStatus === true ? "#9FD983" : rowData.filerStatus === false ? "#F8B8A2" : "#f7cb74",
                    padding: "5px 16px 7px",
                    borderRadius: "10px",
                    textAlign: "center",
                    width: "max-content"
                  }}
                >
                  {rowData.filerStatus === true ? "Active" : rowData.filerStatus === false ? "Inactive" : "N/A"}
                </div>
              ),
            },
            { title: "Created By", field: "userDetails.userName", editable: 'never' },
          ]}
          data={(query) =>
            new Promise((resolve, reject) => {
              let url = `${baseURL}/customers?`;
              url += "limit=" + query.pageSize;
              url += "&page=" + query.page;
              url += "&search=" + query.search;
              fetch(url, {
                method: "GET",
                headers: headers,
              }).then((response) => response.json()).then((result) => {
                resolve({
                  data: result.data,
                  page: result.page,
                  totalCount: result.total_results,
                });
              });
            })
          }
          options={{
            actionsColumnIndex: -1,
            exportButton: true,
            exportAllData: true,
            paging: true,
            pageSize: 50,
            emptyRowsWhenPaging: false,
            pageSizeOptions: [50, 100, 150, 200],
            headerStyle: {
              position: "sticky",
              top: 0,
              color: "#00BBBB",
              fontWeight: "550",
              onRowAdd: "none",
              whiteSpace: 'nowrap',
            },
            rowStyle: {
              whiteSpace: 'nowrap',
            },
            cellStyle: {
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            },
            exportPdf: (columns, data) => {
              const unit = "pt";
              const size = "A4";
              const orientation = "p";
              const doc = new jsPDF(orientation, unit, size);
              PDFHeader(doc, "Customer Details");

              const columnTitles = columns.map(columnDef => columnDef.title);
              const pdfData = data.map((elt) => [
                elt.sequenceNumber,
                elt.name,
                elt.phone,
                elt.email,
                elt.address,
                elt.filerStatus === true ? "Active" : elt.filerStatus === false ? "Inactive" : "N/A",
              ]);
              let content = {
                startY: 120,
                startX: 5,
                head: [columnTitles],
                body: pdfData,
                headStyles: { fillColor: "#2980ba", font: 'Amiri', fontSize: 10 },
                styles: { fontSize: 9 },
                theme: "grid",
              };

              doc.setFontSize(11)
              doc.setFont("Times New Roman", "Normal")
              doc.autoTable(content);

              doc.setProperties({ title: 'Customer Details' })
              doc.output('dataurlnewwindow')
            },
          }}
          editable={{
            isDeleteHidden: (rowData) => Checkpermissions("permissionsSubCatName", "Customer Delete"),
            onRowDelete: (oldData) =>
              new Promise((resolve) => {
                setTimeout(() => {
                  resolve();
                  props.deleteCustomer(oldData._id);
                  tableRef.current && tableRef.current.onQueryChange();
                }, 600);
              }),
          }}
          actions={[
            {
              icon: "refresh",
              tooltip: "Refresh Data",
              isFreeAction: true,
              onClick: () => tableRef.current && tableRef.current.onQueryChange(),
            },
            (rowData) => ({
              hidden: Checkpermissions("permissionsSubCatName", "Customer Edit"),
              icon: () => <EditIcon />,
              tooltip: "Edit Customer",
              onClick: (_e, rowData) => handleEditClick(rowData),
            }),
          ]}
        />
      </Container>
    </>
  );
};
const mapDispatchToProps = (dispatch) => {
  return {
    deleteCustomer: (customerId) => dispatch(deleteCustomer(customerId)),
    updateCustomer: (newData, oldData) => dispatch(updateCustomer(newData, oldData)),
    setHeading: (data) => dispatch(setHeading(data)),
  };
};
const mapStateToProps = (state, ownProps) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(ViewCustomer);